export default __webpack_public_path__ + "static/media/contactsInTabLight.242a5b07.svg";